import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home').then(module => ({ default: module.Home })));
const Agencies = lazy(() => import('./pages/Agencies').then(module => ({ default: module.Agencies })));
const WebsiteOwners = lazy(() => import('./pages/WebsiteOwners').then(module => ({ default: module.WebsiteOwners })));
const Pricing = lazy(() => import('./pages/Pricing').then(module => ({ default: module.Pricing })));
const Infrastructure = lazy(() => import('./pages/Infrastructure').then(module => ({ default: module.Infrastructure })));
const Contact = lazy(() => import('./pages/Contact').then(module => ({ default: module.Contact })));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(module => ({ default: module.PrivacyPolicy })));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions').then(module => ({ default: module.TermsAndConditions })));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy').then(module => ({ default: module.RefundPolicy })));
const AboutUs = lazy(() => import('./pages/AboutUs').then(module => ({ default: module.AboutUs })));
const Support = lazy(() => import('./pages/Support').then(module => ({ default: module.Support })));
const Compare = lazy(() => import('./pages/Compare').then(module => ({ default: module.Compare })));
const Sitemap = lazy(() => import('./pages/Sitemap').then(module => ({ default: module.Sitemap })));

// Tools
const ToolsIndex = lazy(() => import('./pages/tools/ToolsIndex').then(module => ({ default: module.ToolsIndex })));
const DnsLookup = lazy(() => import('./pages/tools/DnsLookup').then(module => ({ default: module.DnsLookup })));
const WebsiteAudit = lazy(() => import('./pages/tools/WebsiteAudit').then(module => ({ default: module.WebsiteAudit })));
const HostingChecker = lazy(() => import('./pages/tools/HostingChecker').then(module => ({ default: module.HostingChecker })));
const DomainChecker = lazy(() => import('./pages/tools/DomainChecker').then(module => ({ default: module.DomainChecker })));
const DomainGenerator = lazy(() => import('./pages/tools/DomainGenerator').then(module => ({ default: module.DomainGenerator })));
const DomainWhois = lazy(() => import('./pages/tools/DomainWhois').then(module => ({ default: module.DomainWhois })));
const RobotsValidator = lazy(() => import('./pages/tools/RobotsValidator').then(module => ({ default: module.RobotsValidator })));

// Loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-olo-dark">
    <div className="w-8 h-8 border-4 border-olo-teal border-t-transparent rounded-full animate-spin"></div>
  </div>
);

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="agencies" element={<Agencies />} />
            <Route path="owners" element={<WebsiteOwners />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="infrastructure" element={<Infrastructure />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="support" element={<Support />} />
            <Route path="compare" element={<Compare />} />
            <Route path="sitemap" element={<Sitemap />} />
            
            {/* SEO Tools Routes */}
            <Route path="tools" element={<ToolsIndex />} />
            <Route path="tools/dns-lookup" element={<DnsLookup />} />
            <Route path="tools/website-audit" element={<WebsiteAudit />} />
            <Route path="tools/hosting-checker" element={<HostingChecker />} />
            <Route path="tools/domain-checker" element={<DomainChecker />} />
            <Route path="tools/domain-generator" element={<DomainGenerator />} />
            <Route path="tools/domain-whois" element={<DomainWhois />} />
            <Route path="tools/robots-validator" element={<RobotsValidator />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}
